document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-reference-product]');
  if (!root) return;
  const form = root.querySelector('form');
  const variants = JSON.parse(document.querySelector('[data-reference-variants]').textContent);
  const groups = JSON.parse(document.querySelector('[data-reference-catalog]').textContent);
  const labels = JSON.parse(document.querySelector('[data-reference-labels]').textContent);
  const catalog = groups.flatMap(group => group.options);
  const button = root.querySelector('.ref-add');
  const currency = labels.currency || 'USD';
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
  const initialId = new URLSearchParams(location.search).get('variant');
  const initialVariant = variants.find(variant => String(variant.id) === initialId) ||
    variants.find(variant => variant.option1.toLowerCase() === 'gold' && Number(variant.option2) === 4) || variants[0];
  const builders = [...root.querySelectorAll('[data-charm-builder]')].map((element, index) => ({
    element, index,
    state: { metal: initialVariant.option1.toLowerCase(), count: Number(initialVariant.option2), selections: [null, null, null, null], attempted: false }
  }));
  const getVariant = state => variants.find(variant => variant.option1.toLowerCase() === state.metal && Number(variant.option2) === state.count);
  const closeMenus = () => root.querySelectorAll('.cb-dropdown.cb-open').forEach(menu => {
    menu.classList.remove('cb-open');
    menu.previousElementSibling.setAttribute('aria-expanded', 'false');
  });
  const safeIcon = (option, size, metal) => {
    if (option.isLetter) {
      const span = document.createElement('span');
      span.className = 'cb-letter ' + metal;
      span.textContent = option.label;
      span.style.fontSize = size + 'px';
      return span;
    }
    const wrap = document.createElement('span');
    wrap.className = 'cb-icon-crop';
    wrap.style.width = size + 'px';
    wrap.style.height = size + 'px';
    const image = document.createElement('img');
    image.src = metal === 'silver' ? option.silverImg : option.goldImg;
    image.alt = '';
    image.loading = 'lazy';
    image.decoding = 'async';
    if (option.zoom) image.style.transform = 'scale(' + option.zoom + ')';
    wrap.append(image);
    return wrap;
  };
  const updateOffer = () => {
    const selected = builders.map(builder => getVariant(builder.state));
    const total = Math.max(...selected.map(variant => variant?.price || 0));
    root.querySelectorAll('[data-reference-price], [data-bogo-total]').forEach(node => { node.textContent = money(total); });
    root.querySelector('[data-bogo-paid-price]').textContent = money(total);
    button.disabled = form.getAttribute('aria-busy') === 'true' || selected.some(variant => !variant?.available);
  };
  const render = builder => {
    const { element, index, state } = builder;
    const variant = getVariant(state);
    element.querySelector('[data-variant-id]').value = variant?.id || '';
    if (index === 0 && variant) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState(null, '', url);
    }
    element.querySelector('[data-count-display]').textContent = state.count;
    element.querySelectorAll('[data-metal]').forEach(control => {
      const active = control.dataset.metal === state.metal;
      control.classList.toggle('active', active);
      control.setAttribute('aria-pressed', String(active));
    });
    element.querySelectorAll('[data-count]').forEach(control => {
      const active = Number(control.dataset.count) === state.count;
      control.classList.toggle('active', active);
      control.setAttribute('aria-pressed', String(active));
    });
    const preview = element.querySelector('[data-preview]');
    preview.replaceChildren();
    for (let choice = 0; choice < 4; choice++) {
      const active = choice < state.count;
      const row = element.querySelector('[data-choice-row="' + choice + '"]');
      row.hidden = !active;
      const selected = catalog.find(option => option.value === state.selections[choice]);
      const property = row.querySelector('[data-charm-property]');
      property.disabled = !active;
      property.value = active && selected ? (selected.isLetter ? labels.initial + ' ' + selected.label : selected.label) : '';
      const host = row.querySelector('.cb-custom-select');
      host.replaceChildren();
      const trigger = document.createElement('button');
      const controlId = 'cb-' + (index + 1) + '-choice-' + (choice + 1);
      trigger.id = controlId;
      trigger.type = 'button';
      trigger.className = 'cb-trigger' + (selected ? '' : ' cb-placeholder');
      trigger.style.width = '100%';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', controlId + '-options');
      trigger.setAttribute('aria-label', labels.bracelet + ' ' + (index + 1) + ', ' + labels.choice + ' ' + (choice + 1) + ': ' + (selected ? selected.label : labels.placeholder));
      if (state.attempted && active && !selected) { trigger.classList.add('cb-error'); trigger.setAttribute('aria-invalid', 'true'); }
      if (selected) {
        const icon = document.createElement('span'); icon.className = 'cb-icon-box';
        icon.append(safeIcon(selected, 18, state.metal)); trigger.append(icon);
      }
      const text = document.createElement('span'); text.className = 'cb-trigger-text';
      text.textContent = selected ? selected.label : labels.placeholder; trigger.append(text);
      const menu = document.createElement('div'); menu.id = controlId + '-options'; menu.className = 'cb-dropdown';
      menu.setAttribute('role', 'listbox'); menu.setAttribute('aria-label', labels.choice + ' ' + (choice + 1));
      const choose = option => {
        state.selections[choice] = option.value;
        render(builder);
        element.querySelector('#' + controlId).focus();
      };
      groups.forEach(group => {
        const title = document.createElement('div'); title.className = 'cb-group-label'; title.textContent = group.label; menu.append(title);
        group.options.forEach(option => {
          const item = document.createElement('div');
          item.className = 'cb-option' + (selected?.value === option.value ? ' cb-selected' : '');
          item.tabIndex = -1; item.setAttribute('role', 'option'); item.setAttribute('aria-selected', String(selected?.value === option.value)); item.dataset.value = option.value;
          const icon = document.createElement('span'); icon.className = 'cb-icon-box'; icon.append(safeIcon(option, 20, state.metal));
          const label = document.createElement('span'); label.textContent = option.label; item.append(icon, label);
          item.addEventListener('click', event => { event.stopPropagation(); choose(option); });
          item.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(option); }
            else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
              event.preventDefault(); const options = [...menu.querySelectorAll('[role=option]')];
              const next = options.indexOf(item) + (event.key === 'ArrowDown' ? 1 : -1);
              options[(next + options.length) % options.length].focus();
            } else if (event.key === 'Escape') { closeMenus(); trigger.focus(); }
          });
          menu.append(item);
        });
      });
      trigger.addEventListener('click', event => {
        event.stopPropagation(); const wasOpen = menu.classList.contains('cb-open'); closeMenus();
        if (!wasOpen) { menu.classList.add('cb-open'); trigger.setAttribute('aria-expanded', 'true'); }
      });
      trigger.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); closeMenus(); menu.classList.add('cb-open'); trigger.setAttribute('aria-expanded', 'true');
          (menu.querySelector('[aria-selected=true]') || menu.querySelector('[role=option]')).focus();
        } else if (event.key === 'Escape') closeMenus();
      });
      host.append(trigger, menu);
      if (active) {
        const slot = document.createElement('div'); slot.className = 'cb-preview-slot' + (selected ? ' filled' : '') + (state.metal === 'silver' ? ' silver' : '');
        slot.setAttribute('aria-label', labels.choice + ' ' + (choice + 1) + (selected ? ': ' + property.value : ''));
        if (selected) slot.append(safeIcon(selected, selected.isLetter ? 34 : 60, state.metal));
        preview.append(slot);
      }
    }
    const incomplete = state.selections.slice(0, state.count).some(value => !value);
    const status = element.closest('details').querySelector('[data-bracelet-status]');
    status.textContent = incomplete ? labels.choose : labels.ready;
    status.classList.toggle('is-ready', !incomplete);
    const error = element.querySelector('[data-builder-error]');
    error.textContent = variant?.available ? labels.selectionError : labels.unavailable;
    error.classList.toggle('cb-show', state.attempted && (incomplete || !variant?.available));
    updateOffer();
  };
  builders.forEach(builder => {
    const { element, state } = builder;
    element.querySelectorAll('[data-metal]').forEach(control => control.addEventListener('click', () => { state.metal = control.dataset.metal; render(builder); }));
    element.querySelectorAll('[data-count]').forEach(control => control.addEventListener('click', () => {
      state.count = Number(control.dataset.count);
      state.selections = state.selections.map((value, index) => index < state.count ? value : null);
      render(builder);
    }));
    element.querySelector('[data-reset]').addEventListener('click', () => { state.selections = [null, null, null, null]; state.attempted = false; render(builder); });
  });
  document.addEventListener('click', event => { if (!event.target.closest('.cb-custom-select')) closeMenus(); });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    builders.forEach(builder => { builder.state.attempted = true; render(builder); });
    const invalid = builders.find(builder => builder.state.selections.slice(0, builder.state.count).some(value => !value) || !getVariant(builder.state)?.available);
    if (invalid) {
      invalid.element.closest('details').open = true;
      const first = invalid.element.querySelector('.cb-trigger[aria-invalid=true]') || invalid.element.querySelector('[data-builder-error]');
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      first.focus({ preventScroll: true });
      return;
    }
    const pair = window.crypto?.randomUUID?.() || String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    const items = builders.map(builder => {
      const properties = { Bracelet: labels.bracelet + ' ' + (builder.index + 1), _jr_offer: 'zodiac-bogo', _jr_pair: pair };
      builder.state.selections.slice(0, builder.state.count).forEach((value, index) => {
        const option = catalog.find(item => item.value === value);
        properties[labels.propertyPrefix + ' ' + (index + 1)] = option.isLetter ? labels.initial + ' ' + option.label : option.label;
      });
      return { id: getVariant(builder.state).id, quantity: 1, properties };
    });
    const buttonContents = [...button.childNodes];
    const cartLabels = window.JuneReedCart.labels;
    const error = root.querySelector('[data-offer-error]');
    form.setAttribute('aria-busy', 'true');
    builders.forEach(builder => { builder.element.inert = true; });
    button.disabled = true; button.textContent = cartLabels.loading; error.hidden = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : cartLabels.error);
      await window.JuneReedCart.open();
    } catch (failure) {
      error.textContent = failure.message || cartLabels.error; error.hidden = false;
    } finally {
      form.removeAttribute('aria-busy'); builders.forEach(builder => { builder.element.inert = false; });
      button.replaceChildren(...buttonContents); updateOffer();
    }
  });
  builders.forEach(render);

  root.querySelectorAll('[data-gallery]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-gallery]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));root.querySelectorAll('[data-photo]').forEach(photo=>photo.hidden=photo.dataset.photo!==button.dataset.gallery)}));
  const dialog=document.querySelector('.ref-media-dialog');const content=dialog.querySelector('[data-media-content]');
  const openMedia=(src,type)=>{content.replaceChildren();const media=document.createElement(type==='video'?'video':'img');media.src=src;if(type==='video'){media.controls=true;media.autoplay=true;media.playsInline=true}else media.alt=labels.media;content.append(media);dialog.showModal()};
  dialog.querySelector('[data-media-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close()});dialog.addEventListener('close',()=>{content.querySelector('video')?.pause();content.replaceChildren()});
  root.querySelectorAll('[data-photo] img').forEach(image=>{image.tabIndex=0;image.setAttribute('role','button');image.setAttribute('aria-label',labels.zoom);image.addEventListener('click',()=>openMedia(image.src,'image'));image.addEventListener('keydown',event=>{if(event.key==='Enter')openMedia(image.src,'image')})});
  document.querySelectorAll('.los-card,.ugc-card').forEach(card=>{card.tabIndex=0;card.setAttribute('role','button');card.setAttribute('aria-label',card.dataset.video?labels.play:labels.media);const action=()=>openMedia(card.dataset.video||card.dataset.src,card.dataset.video?'video':card.dataset.type);card.addEventListener('click',action);card.addEventListener('keydown',event=>{if(event.key==='Enter')action()})});
  const track=document.querySelector('#mobileTrack');const dots=[...document.querySelectorAll('.nolaire-dots .dot')];let reviewIndex=0;
  const slideReviews=index=>{reviewIndex=index;if(track)track.style.transform='translateX(-'+index*100+'%)';dots.forEach((dot,i)=>{dot.classList.toggle('active',i===index);dot.setAttribute('aria-pressed',String(i===index))})};
  dots.forEach((dot,index)=>{dot.tabIndex=0;dot.setAttribute('role','button');dot.setAttribute('aria-label',labels.review+' '+(index+1));dot.addEventListener('click',()=>slideReviews(index));dot.addEventListener('keydown',event=>{if(event.key==='Enter')slideReviews(index)})});
  let touchStart=0;track?.addEventListener('touchstart',event=>touchStart=event.changedTouches[0].screenX,{passive:true});track?.addEventListener('touchend',event=>{const dx=event.changedTouches[0].screenX-touchStart;if(Math.abs(dx)>40)slideReviews((reviewIndex+(dx<0?1:-1)+dots.length)%dots.length)},{passive:true});
  document.querySelector('[data-category-next]')?.addEventListener('click',()=>{const track=document.querySelector('.ref-category-track');track.scrollBy({left:track.clientWidth*.7,behavior:'smooth'})});
  const sticky=document.querySelector('.ref-sticky-add');new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||root.getBoundingClientRect().bottom>innerHeight+400},{threshold:0}).observe(root.querySelector('.ref-add'));document.addEventListener('scroll',()=>{const button=root.querySelector('.ref-add').getBoundingClientRect();sticky.hidden=button.bottom>0},{passive:true});sticky.querySelector('[data-sticky-add]').addEventListener('click',()=>{form.scrollIntoView({behavior:'smooth',block:'start'});root.querySelector('.ref-add').focus()});
});

